// extracted by mini-css-extract-plugin
module.exports = {"PrivacyPolicy":"styles_PrivacyPolicy__MCDTE","parentList":"styles_parentList__RAQPN","childList":"styles_childList__v8LOM"};